// src/components/Dashboard/AdminPartner.js
import React, { useState, useEffect } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../../services/firebase';
import ApplicationModal from './ApplicationModal';

const AdminPartner = () => {
  const [applications, setApplications] = useState([]);
  const [filteredApplications, setFilteredApplications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedApplication, setSelectedApplication] = useState(null);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const fetchApplications = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, 'partnerApplications'));
        const apps = [];
        querySnapshot.forEach((doc) => {
          const data = doc.data();
          apps.push({ 
            id: doc.id, 
            type: 'partner', 
            name: data.entityRegisteredName || data.tradingName || data.businessName || 'N/A', 
            entityRegisteredName: data.entityRegisteredName || data.businessName || 'N/A',
            tradingName: data.tradingName || data.businessName || 'N/A',
            liaisonTitleFullNames: data.liaisonTitleFullNames || data.contactPerson || 'N/A',
            businessEmail: data.businessEmail || data.email || 'N/A',
            submittedAt: data.submittedAt || data.createdAt || null,
            ...data 
          });
        });
        setApplications(apps);
        setFilteredApplications(apps);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching partner applications:', error);
        setLoading(false);
      }
    };

    fetchApplications();
  }, []);

  useEffect(() => {
    const filtered = applications.filter(app => 
      app.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      (app.businessEmail && app.businessEmail.toLowerCase().includes(searchTerm.toLowerCase())) ||
      (app.liaisonTitleFullNames && app.liaisonTitleFullNames.toLowerCase().includes(searchTerm.toLowerCase()))
    );
    setFilteredApplications(filtered);
  }, [searchTerm, applications]);

  const viewApplicationDetails = (application) => {
    setSelectedApplication(application);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setSelectedApplication(null);
  };

  if (loading) {
    return <div className="loading">Loading partner applications...</div>;
  }

  return (
    <div className="dashboard-section">
      <h3>Partner Applications ({applications.length})</h3>
      
      <div className="search-container">
        <input
          type="text"
          placeholder="Search by name, email, or contact person..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="search-input"
        />
      </div>

      <div className="table-container">
        <table className="dashboard-table">
          <thead>
            <tr>
              <th>Type</th>
              <th>Business Name</th>
              <th>Contact Person</th>
              <th>Email</th>
              <th>Submitted Date</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredApplications.map(application => (
              <tr key={`partner-${application.id}`}>
                <td>
                  <span className="type-badge type-partner">Partner</span>
                </td>
                <td>{application.entityRegisteredName || application.tradingName || 'N/A'}</td>
                <td>{application.liaisonTitleFullNames || 'N/A'}</td>
                <td>{application.businessEmail || 'N/A'}</td>
                <td>
                  {application.submittedAt
                    ? new Date(application.submittedAt.seconds * 1000).toLocaleDateString()
                    : 'N/A'}
                </td>
                <td>
                  <span className={`status-badge status-${application.status || 'pending'}`}>
                    {application.status || 'Pending'}
                  </span>
                </td>
                <td>
                  <button
                    className="btn-primary"
                    onClick={() => viewApplicationDetails(application)}
                  >
                    View Details
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {filteredApplications.length === 0 && (
          <p className="no-data">
            {searchTerm ? 'No matching partner applications found.' : 'No partner applications found.'}
          </p>
        )}
      </div>

      {showModal && selectedApplication && (
        <ApplicationModal 
          application={selectedApplication} 
          onClose={closeModal} 
        />
      )}
    </div>
  );
};

export default AdminPartner;